import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RadioTileGroup, RadioTileGroupProps } from '@sato/components';

interface Props<T extends string>
  extends Omit<RadioTileGroupProps<T>, 'onChange' | 'value'> {
  name: string;
}

export const HookFormRadioTileGroup = <T extends string>(props: Props<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <RadioTileGroup
          {...props}
          {...field}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
